import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Select } from "components"
import classes from "./RrDispatchedSelect.module.scss"

const RrDispatchedSelect = props => {
  const { filter, setFilter } = props

  const [t, i18n] = useTranslation()

  const handleSelect = (select) => {
    setFilter(prev => ({
      ...prev,
      isDispatched: select?.value || null
    }))
  }

  const options = [
    { label: t("خروج_از_انبار"), value: true },
    { label: t("خروج_نخورده"), value: false }
  ]

  const value =
    options.find(o => o.value === filter.isDispatched)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Select
      isClearable
      label={t("وضعیت_خروج")}
      options={options}
      value={value}
      noOptionsMessage={() => null}
      onChange={handleSelect}
      className={clsx(
        classes["input"],
        isLtr && classes["input-ltr"]
      )}
    />
  )
}

export default RrDispatchedSelect